// extracted by mini-css-extract-plugin
export const subscribe = "Subscribe-module--subscribe--3CYlY";
export const title = "Subscribe-module--title--Bx-qn";
export const form = "Subscribe-module--form--2vCzj";